import React from 'react';

import { TableCell, TableRow, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { isTruncated } from '../../../lib/helpers/helpers';

const useStyles = makeStyles((theme) => ({
  tableRow: theme.globalClasses.adminTableRowWrapper,
  description: {
    maxWidth: '400px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    lineHeight: '1.2em',
    maxHeight: '2.4em', // 2 lines × 1.2em line-height
  },
  name: {
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const PatientRecommendedChallengesRow = ({ row }) => {
  const classes = useStyles();

  return (
    <>
      <TableRow
        tabIndex={-1}
        id={row.id}
        key={row.id}
        className={classes.tableRow}
      >
        <TableCell align="left">
          {isTruncated(row.name, 25) ? (
            <Tooltip
              title={row.name}
              placement="top"
            >
              <div className={classes.name}>{row.name ?? 'N/A'}</div>
            </Tooltip>
          ) : (
            <div className={classes.name}>{row.name ?? 'N/A'}</div>
          )}
        </TableCell>
        <TableCell align="left">
          {isTruncated(row.description, 100) ? (
            <Tooltip
              title={row.description}
              placement="top"
            >
              <div className={classes.description}>{row.description ?? 'N/A'}</div>
            </Tooltip>
          ) : (
            <div className={classes.description}>{row.description ?? 'N/A'}</div>
          )}
        </TableCell>
        <TableCell align="left">{row.success_rate ?? 'N/A'}</TableCell>
        <TableCell align="left">{row.positive_days ?? 'N/A'}</TableCell>
      </TableRow>
    </>
  );
};

export default PatientRecommendedChallengesRow;
